import { User } from "oidc-client";
import { UserRole } from "./userRole";

export const isAdminUser = (user: User | undefined): boolean => {
  let hasAccess = false;

  if (user && user.profile.role) {
    let role: UserRole = user.profile.role;

    hasAccess = role === "admin" || role === "admin-reader";
  }
 
  return hasAccess;
}

export const isLoginRequiredError = (error: unknown): boolean => {
  if (error instanceof Error) {
    return error.message === "login_required";
  }

  return false;
}